import React, {useCallback, useEffect, useState} from 'react';

export const useHiddenRegDocState = () => {
	const storageKey = 'TRACE_HIDDEN_DOC';
	// Helper to read from localStorage
	const getAllStates = (): Record<string, boolean> => {
		const stored = localStorage.getItem(storageKey);
		return stored ? JSON.parse(stored) : {};
	};

	// Initialize from localStorage
	const [states, setStates] = useState<Record<string, boolean>>(() =>
		getAllStates(),
	);

	// Save to localStorage whenever states change
	useEffect(() => {
		localStorage.setItem(storageKey, JSON.stringify(states));
	}, [states]);

	// Sync with changes from other tabs
	useEffect(() => {
		const handleStorage = (e: StorageEvent) => {
			if (e.key === storageKey && e.newValue) {
				setStates(JSON.parse(e.newValue));
			}
		};
		window.addEventListener('storage', handleStorage);
		return () => window.removeEventListener('storage', handleStorage);
	}, []);

	// Get state for an ID
	const isHidden = useCallback(
		(id: string): boolean => {
			return states[id] ?? false;
		},
		[states],
	);

	// Set state for an ID
	const setIsHidden = useCallback((id: string, hidden: boolean) => {
		setStates(prev => ({
			...prev,
			[id]: hidden,
		}));
	}, []);

	return {isHidden, setIsHidden};
};
